import Scenario2Part1 from './Scenario2Part1';
import Scenario2Part2 from './Scenario2Part2';
import Scenario2Part3 from './Scenario2Part3';
import Scenario2Part4 from './Scenario2Part4';
import Scenario2Part5 from './Scenario2Part5';
import Scenario2Part6 from './Scenario2Part6';
import Scenario2Part7 from './Scenario2Part7';
import Scenario2Part8 from './Scenario2Part8';
import Scenario2Part9 from './Scenario2Part9';
import GameManager from '../../cvp-webgames-core/GameManager';
import { constants } from '../../misc/constants';
import BaseScenarioPart from '../../cvp-webgames-core/Scenario/BaseScenarioPart';
import { VideoEnvironmentProps } from '../../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import { MedsurgBaseScenario, ScenarioData } from '../MedsurgBaseScenario';

export default class Scenario2 extends MedsurgBaseScenario {
	public PrRothID: string;
	public PrChangID: string;
	public PrPhillipsID: string;
	public PrRamirezID: string;
	public rothVitalsID: string = 'rothVitals';
	public rothNursesID: string = 'rothNurses';
	public rothBasicID: string = 'rothBasic';
	public changVitalsID: string = 'changVitals';
	public changNursesID: string = 'changNurses';
	public changBasicID: string = 'changBasic';
	public phillipsVitalsID: string = 'phillipsVitals';
	public phillipsNursesID: string = 'phillipsNurses';
	public phillipsBasicID: string = 'phillipsBasic';
	public ramirezVitalsID: string = 'ramirezVitals';
	public ramirezNursesID: string = 'ramirezNurses';
	public ramirezBasicID: string = 'ramirezBasic';
	public scenarioData: ScenarioData = {
		entries: [{
			id: this.rothVitalsID,
			items: []
		},
		{
			id: this.rothNursesID,
			items: []
		},
		{
			id: this.rothBasicID,
			items: []
		},
		{
			id: this.changVitalsID,
			items: []
		},
		{
			id: this.changNursesID,
			items: []
		},
		{
			id: this.changBasicID,
			items: []
		},
		{
			id: this.phillipsVitalsID,
			items: []
		},
		{
			id: this.phillipsNursesID,
			items: []
		},
		{
			id: this.phillipsBasicID,
			items: []
		},
		{
			id: this.ramirezVitalsID,
			items: []
		},
		{
			id: this.ramirezNursesID,
			items: []
		},
		{
			id: this.ramirezBasicID,
			items: []
		}]
	};

	public getScenarioData(): ScenarioData {
		return this.scenarioData;
	};

	public setScenarioData(data: ScenarioData): void {
		this.scenarioData = data;
	};

	parts: BaseScenarioPart<MedsurgBaseScenario>[] = [
		new Scenario2Part1(this, () => {this.goToPart2()}),
		new Scenario2Part2(this, () => {this.goToPart3()}),
		new Scenario2Part3(this, () => {this.goToPart4()}),
		new Scenario2Part4(this, () => {this.goToPart5()}),
		new Scenario2Part5(this, () => {this.goToPart6()}),
		new Scenario2Part6(this, () => {this.goToPart7()}),
		new Scenario2Part7(this, () => {this.goToPart8()}),
		new Scenario2Part8(this, () => {this.goToPart9()}),
		new Scenario2Part9(this, () => {this.goToScenarioEnd()})
	]
	public get totalNumberOfQuestions(): number {
		return 5;
	}
	
	public getEnviromentProps(): VideoEnvironmentProps {
		return {
			controls: true
		};
	}
	
    public get currentLevel(): number {
        return 1;
    }

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
	}

	public getParts(): BaseScenarioPart<MedsurgBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return './assets/audio/scenario2/' + fileName + '.mp3';
	}

	start() {
		this.gameManager.UiManager.createUIInstance(constants.uiNames.SplashScreenUI);
		this.goToPart1();
	}

	goToPart1() {
		this.loadPart(constants.scenarios.scenario2.parts.level2Part1.id, () => {
			this.destroyAllUIInstances();
        });
	}

	goToPart2() {
		this.loadPart(constants.scenarios.scenario2.parts.level2Part2.id, () => {
			this.destroyAllUIInstances();
        });
	}

	goToPart3() {
		this.loadPart(constants.scenarios.scenario2.parts.level2Part3.id, () => {
			this.destroyAllUIInstances();
        });
	}

	goToPart4() {
		this.loadPart(constants.scenarios.scenario2.parts.level2Part4.id, () => {
			this.destroyAllUIInstances();
        });
	}

	goToPart5() {
		this.loadPart(constants.scenarios.scenario2.parts.level2Part5.id, () => {
			this.destroyAllUIInstances();
        });
	}

	goToPart6() {
		this.loadPart(constants.scenarios.scenario2.parts.level2Part6.id, () => {
			this.destroyAllUIInstances();
        });
	}

	goToPart7() {
		this.loadPart(constants.scenarios.scenario2.parts.level2Part7.id, () => {
			this.destroyAllUIInstances();
        });
	}

	goToPart8() {
		this.loadPart(constants.scenarios.scenario2.parts.level2Part8.id, () => {
			this.destroyAllUIInstances();
        });
	}

	goToPart9() {
		this.loadPart(constants.scenarios.scenario2.parts.level2Part9.id, () => {
			this.destroyAllUIInstances();
        });
	}

	goToScenarioEnd() {
	}
}
